<template>
    <div class="card border-primary border-darken-1">
        <div class="card-body">
            <h5 class="card-title mb-1 text-primary mb-2">
                {{ localizationStore.translate('fax.settings') }}
            </h5>
            <a :href="settingStore.clicksend.signup" target="_blank" class="btn-sm btn-outline-primary mr-50">
                <i data-feather="external-link" class="mr-25"></i>
                <span>
                    {{ localizationStore.translate('fax.clicksend.signup') }}
                </span>
            </a>
            <a :href="settingStore.clicksend.pricing" target="_blank" class="btn-sm btn-outline-primary">
                <i data-feather="external-link" class="mr-25"></i>
                <span>
                    {{ localizationStore.translate('fax.clicksend.pricing') }}
                </span>
            </a>
            <div class="row mt-2">
                <div class="col-6">
                    <div class="form-group">
                        <div class="controls">
                            <label for="clicksend-username">
                                {{ localizationStore.translate('fax.clicksend.username') }}
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                :placeholder="localizationStore.translate('fax.clicksend.username.placeholder')"
                                id="clicksend_username"
                                name="clicksend_username"
                                v-model="settingStore.clicksend.clicksend_username"
                                :data-validation-required-message="localizationStore.translate('fax.clicksend.username.error.message')"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <div class="controls">
                            <label for="clicksend-password">
                                {{ localizationStore.translate('fax.clicksend.password') }}
                            </label>
                            <input
                                type="password"
                                class="form-control"
                                :placeholder="localizationStore.translate('fax.clicksend.password.placeholder')"
                                id="clicksend_password"
                                name="clicksend_password"
                                v-model="settingStore.clicksend.clicksend_password"
                                :data-validation-required-message="localizationStore.translate('fax.clicksend.password.error.message')"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group mb-0">
                        <div class="controls">
                            <label for="clicksend-fax-number">
                                {{ localizationStore.translate('fax.clicksend.fax.number') }}
                            </label>
                            <phone-input-component
                                @phoneInput="settingStore.updateFaxNumber"
                                name="clicksend_fax_number"
                                :prop-phone="settingStore.clicksend.clicksend_fax_number"
                            ></phone-input-component>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group mb-0">
                        <div class="controls">
                            <label for="for shared fax number">
                                <a target="_blank" :href="settingStore.clicksend.fax_numbers">
                                    Leave {{ localizationStore.translate('fax.clicksend.fax.number') }} blank to use free <strong>“shared”</strong> fax number or click here to purchase a <strong>“dedicated”</strong> fax number.
                                </a>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <button @click="settingStore.updateFaxSetting()" class="btn btn-primary mt-2 mr-1">
                        {{ localizationStore.translate('save.changes') }}
                    </button>
                    <button type="reset" class="btn btn-outline-secondary mt-2">
                        {{ localizationStore.translate('cancel') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { defineComponent, ref, onBeforeMount } from 'vue'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { useSettingStore } from '../../stores/SettingStore.js'

    export default defineComponent({
        name: 'FaxSetting',
        props: {
        },
        components: {
        },
        setup(props) {
            return {
                localizationStore: useLocalizationStore(),
                settingStore: useSettingStore(),
            }
        },
        mounted() {
            useSettingStore().fetchSetting();
        },
        created() {
        },
        methods: {
        }
    });
</script>
